export const SSH_ACCESS_HASH = "#Access";

export interface SshAccessNavigationState {
  scrollToSshAccess?: boolean;
}

export const SSH_ACCESS_NAVIGATION_STATE: SshAccessNavigationState = {
  scrollToSshAccess: true,
};

export const shouldScrollToSshAccess = (
  hash: string,
  state?: SshAccessNavigationState,
) => hash === SSH_ACCESS_HASH && state?.scrollToSshAccess === true;
